import { MenuItem as MuiMenuItem, Select as MuiSelect } from '@mui/material';
import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps, forwardRef, ReactElement } from 'react';
import styles from './Select.module.scss';

type SelectChild = ReactElement<ComponentProps<typeof Option>>;

export type SelectProps = {
  size?: 'small' | 'medium';
  placeholder?: string;
  children?: SelectChild | SelectChild[];
  error?: boolean;
};

export const Select = forwardRef<HTMLInputElement, Omit<ComponentProps<'select'>, 'size'> & SelectProps>(
  ({ placeholder, size = 'medium', error, onChange, className, children, ...rest }, ref) => (
    <MuiSelect
      hiddenLabel
      slotProps={{ root: { className: classNames(styles.select, styles[size], className) } }}
      variant="filled"
      size={size}
      inputRef={ref}
      error={error}
      SelectDisplayProps={{ 'data-placeholder': placeholder }}
      onChange={(e) => onChange?.(e as any)}
      MenuProps={{ classes: { paper: styles.menu } }}
      {...(rest as any)}
    >
      {children}
    </MuiSelect>
  )
);

export function Option({ className, children, ...rest }: ComponentProps<'option'>) {
  return (
    <MuiMenuItem className={classNames(styles.option, className)} {...(rest as any)}>
      {children}
    </MuiMenuItem>
  );
}
